export default "__VITE_ASSET__2be034ed__"